import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-non-completed-order-report",
  templateUrl: "./non-completed-orders-report.component.html",
  styleUrls: ["./non-completed-orders-report.component.scss"],
})
export class NonCompletedOrdersReportComponent implements OnInit {
  requestType: string = "order";
  title: string = "تقرير اوامر الصيانة الغير مكتملة";
  isOrderDone: boolean = false;

  constructor() {}

  ngOnInit() {}
}
